export default "__VITE_ASSET__ABfxh5sR__"